<template>
  <div>
    <b-row v-for="(linha, index) in schema" :key="linha.length + '' + index">
      <b-col v-for="(coluna, index) in linha" :key="coluna.text + '' + index" :md="coluna.largura || '3'">
        <b-form-group :label="coluna.text" v-if="coluna.text == 'Cedente'">
          <input-cedente
            v-model="model[coluna.value]"
            :required="cedenteHabilitado" :mostrarInativo="false" ref="inputCedente" 
            @input="loadComboCedentesCarteiras" :disabled="resolverDesabilitado(coluna['disabled'])" />
        </b-form-group>

        <b-form-group :label="coluna.text" v-if="coluna.tipo == 'single-select'">
          <input-select 
            v-model="model[coluna.value]" :options="cedentesCarteiras"
            :required="cedenteHabilitado" :disabled="resolverDesabilitado(coluna['disabled'])" />
        </b-form-group>

        <b-form-group :label="coluna.text" v-if="coluna.tipo == 'input-text'">
          <b-input v-if="coluna.mask" :ref="coluna.text" v-model="model[coluna.value]" :required="coluna['required']"
            :disabled="resolverDesabilitado(coluna['disabled'])" v-mask="[...coluna.mask.split(',')]" />
          <b-input v-if="!coluna.mask" :ref="coluna.text" v-model="model[coluna.value]" :required="coluna['required']"
            :disabled="resolverDesabilitado(coluna['disabled'])" />
        </b-form-group>

        <b-form-group :label="coluna.text" v-if="coluna.tipo == 'input-date'">
          <input-date v-model="model[coluna.value]" :max="coluna.max || new Date()" :min="coluna.min || new Date()"
           :disabled="resolverDesabilitado(coluna['disabled'])" :ref="coluna.text"></input-date>
        </b-form-group>

        <b-form-group :label="coluna.text || 'Código de Barras'" v-if="coluna.tipo == 'input-codigoBarras'">
          <input-codigoBarras v-model="model[coluna.value]" ></input-codigoBarras>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    schema: Array,
    defaultLoadDates: Function,
    desabilitarCampos: Boolean,
    protestoBoleto: Boolean,
    cedenteHabilitado: Boolean
  },
  data() {
    return {
      cedentesCarteiras: []
    }
  },
  computed: {
    model: {
      get() {
        var obj = this.value
        if (!obj) { obj = {} }
        return obj
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    pesquisarCodBarras: {
      get () {
        return this.desabilitarCampos
      },
      set (value) {
        if (value) {
          this.model = {
            codBarras: this.model.codBarras,
            situacaoBoleto: this.situacaoBoleto.find(x => x.value == null),
            modalidade: this.boletoModalidade.find(x => x.value == null),
            especie: this.boletoEspecie.find(x => x.value == null)
          }
        }
      }
    }
  },
  methods: {
    loadComboCedentesCarteiras (val) {
      if (val) {
        let th = this
        th.cedentesCarteiras = []
        th.model.codigoCedenteCarteira = {}
        th.$api.CedentesCarteiras.Combo(val).then(
          function (data) {
            if (Array.isArray(data) && data.length > 0) {
              let arrayCarteira = []
              data.forEach(function (item) {
                arrayCarteira.push({
                  value: item.guid,
                  text: item.string
                })
              })
              th.cedentesCarteiras = arrayCarteira
            } else {
              th.$api.UI.ShowError(
                'Erro',
                'Nao foram encontrados Carteiras relacionadas ao Cedente.'
              )
            }
          }
        )
      }
    },
    resolverDesabilitado(value) {
      if (value || value === false)
        return value

      return this.desabilitarCampos
    },
    refresh() {
      this.$emit('refresh')
    }
  },
  mounted: function () {
    const th = this;

    th.$nextTick(function () {
      if (th.$refs.inputCedente)
        th.$refs.inputCedente[0].carregaCedentes()
    })

    if (th.defaultLoadDates)
      th.defaultLoadDates();
  },
}
</script>
